import { render, staticRenderFns } from "./Screen.vue?vue&type=template&id=8275981c&scoped=true"
import script from "./Screen.vue?vue&type=script&lang=js"
export * from "./Screen.vue?vue&type=script&lang=js"
import style0 from "./Screen.vue?vue&type=style&index=0&id=8275981c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../imported/work/site/src/project/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8275981c",
  null
  
)

export default component.exports